import { render, staticRenderFns } from "./SalaryCalculatorEquity.vue?vue&type=template&id=6048c313&"
import script from "./SalaryCalculatorEquity.vue?vue&type=script&lang=js&"
export * from "./SalaryCalculatorEquity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports